<template>
  <div>
    <Row class="scoped-row">
      <Col span="3">
        <span class="scoped-title">{{ $t("name.cex_order.count") }}</span>
        <span>{{ row.count }}</span>
      </Col>
      <Col span="7">
        <span class="scoped-title">{{ $t("name.cex_order.price") }}/{{ $t("name.cex_order.add_price") }}</span>
        <span >{{ row.price | money }} <Divider type="vertical" /> {{ row.add_price | money }}</span>
      </Col>
      <Col span="7">
        <span class="scoped-title">{{ $t("name.cex_order.collect") }}/{{ $t("name.cex_order.cost") }}</span>
        <span >{{ row.collect | money }} <Divider type="vertical" /> {{ row.collect_cost | money }}</span>
      </Col>
      <Col span="7">
        <span class="scoped-title">{{ $t("name.cex_order.insure") }}/{{ $t("name.cex_order.cost") }}</span>
        <span >{{ row.insure | money }} <Divider type="vertical" /> {{ row.insure_cost | money }}</span>
      </Col>
    </Row>
    <Divider style="margin:10px 0" dashed />
    <Row class="scoped-row">
      <Col span="3">
        <p><span class="scoped-title">{{ $t('name.cex_order.ref') }}</span>{{ row.ref }}</p>
      </Col>
      <Col span="21">
        <p><span class="scoped-title">{{ $t('name.cex_order.data_name') }}</span>{{ row.data_name }} <Divider type="vertical" /> {{ row.data_phone }} <Divider type="vertical" /> {{ row.data_city }}</p>
      </Col>
    </Row>
    <div class="scoped-row">
      <p v-if="row.remarks"><span class="scoped-title">{{ $t('name.cex_order.remarks') }}</span>{{ row.remarks }}</p>
      <p v-if="row.take_code"><span class="scoped-title">{{ $t('name.cex_order.take_code') }}</span>{{ row.take_code }}</p>
      <p v-if="row.message"><span class="scoped-title">{{ $t('name.cex_order.message') }}</span>{{ row.message }}</p>
      <p v-if="row.track"><span class="scoped-title">{{ $t('name.cex_order.track') }}</span>{{ row.track }}<Divider type="vertical" />{{ row.track_time }} </p>
      <p v-if="row.track_breakdown"><span class="scoped-title">{{ $t('name.cex_order.track_breakdown') }}</span><span class="error">{{ row.track_breakdown }}<Divider type="vertical" />{{ row.track_breakdown_time }}</span></p>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      row: Object
    }
  };
</script>
<style lang="less" scoped>
  @import '@/style/app.less';

  .scoped-row{
    color: @color-content;

    .scoped-title{
      color: @color-sub;
      padding-right: 15px
    }
    
    .error{
      color: @color-error;
    }

    p{
      display: block;
      line-height: 30px;
    }
  }
</style>